import { getIconsBaseUrl } from "~/lib/env";

export type StockBrandingKind = "icon" | "logo";

/**
 * Canonical builder for stock branding image URLs.
 *
 * When VITE_ICONS_BASE_URL is configured, images come from the
 * glider-icons worker (Workers Cache in front — globally tiered, purgeable by
 * tag). Otherwise callers keep the legacy platform-api proxy URL, byte-for-byte
 * identical to the pre-cutover behavior (local dev and tests).
 */
export function buildStockBrandingImageUrl(input: {
  kind?: StockBrandingKind;
  platformApiBaseUrl: string;
  ticker: string;
}): string {
  const kind = input.kind ?? "icon";
  const ticker = encodeURIComponent(input.ticker.trim().toUpperCase());
  const iconsBaseUrl = getIconsBaseUrl();
  if (iconsBaseUrl) {
    return `${iconsBaseUrl.replace(/\/+$/u, "")}/s/${ticker}/${kind}`;
  }

  const baseUrl = input.platformApiBaseUrl.replace(/\/+$/u, "");
  return `${baseUrl}/v1/tradfi-market-data/tickers/${ticker}/branding/${kind}`;
}
